import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const ChevronLeftIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path fill="currentColor" d="M15.759 5.65 10.315 12l5.444 6.35-1.518 1.3-6-7-.558-.65.558-.65 6-7z" />
  </BaseIcon>
)
